import React, { ReactNode } from 'react';

import { FadeInComponent } from '@/components/FadeInComponent';

export const GRID_CLASSES = 'grid gap-x-6 gap-y-12';
export const ICON_COLUMN_SIZE = '50px';
export const GRID_COLUMNS = `repeat(2, ${ICON_COLUMN_SIZE}) 300px repeat(3, 175px)`;

type Props = {
  children: ReactNode;
  className?: string;
}
export function UserPermissionsContentWidth ({ children, className }: Props) {
  return (
    <FadeInComponent
      layout="position"
      className={`px-16 mx-auto ${className || ''}`}
      style={{ width: 1200 }}
    >
      { children }
    </FadeInComponent>
  );
}
